import { gsap } from 'gsap'


export class Hero
{
  constructor(block) {

    this.img = block.querySelector('img')
    this.bgImg = block.querySelector('.background-image')
    this.contentWrapper = block.querySelector('.content-wrapper')

    gsap.set(this.img, { scale: 1 })
    gsap.set(this.contentWrapper, { scale: 0.5, y: 50 })

    if(window.screen.width > 772) {

      gsap.to(this.bgImg, {
        width: '80%',
        x: '10%',
        scrollTrigger: {
          trigger: "body",
          start: "top top",
          end: "bottom top",
          scrub: true,
          //markers: true
        }
      });

    }

    const self = this

    setTimeout(function () {

      gsap.to(self.img, { scale: 1.1, duration: 0.75 })
      gsap.to(self.contentWrapper, { scale: 1,y: 0, duration: 0.75 })

    }, 75)

  }
}

const heroBlocks = document.querySelectorAll('.block-hero')
heroBlocks.forEach( block => {
  new Hero(block)
})
